import {
  Box,
  IconButton,
  Tab,
  Tabs,
  ThemeProvider,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { FiPlus } from "react-icons/fi";
import { IoMdSearch } from "react-icons/io";
import CircularProgress from "../../Common/Components/CircularLoader";
import { theme } from "../../Common/SetupProfile/constant";
import { useListInflucenrs } from "../../hooks/admin/useListInfluencers";
import InfluencerModal from "./InfluencerModal";
import { InfluencersList } from "./Tabs/InfluencersList";

export const InfluencesApproval = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const {
    selectedTab,
    currentPage,
    setSelectedTab,
    setCurrenPage,
    influencers,
    loading,
    total,
    limit,
    listInfluencers,
  } = useListInflucenrs();

  const handleChange = (_, newValue) => {
    setSelectedTab(newValue);
    setCurrenPage(1);
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <Box
          sx={{
            height: "calc(100vh - 126px)",
            overflow: "hidden",
          }}
        >
          <Box display={"flex"} justifyContent={"space-between"}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "20px",
                "& span": {
                  fontWeight: 400,
                  fontSize: "12px",
                },
              }}
            >
              Influencers <span>({total})</span>
            </Typography>
            <Box display={"flex"} gap={2}>
              <Tooltip title="Search">
                <IconButton
                  sx={{
                    border: "1px solid #DDDDDD",
                  }}
                >
                  <IoMdSearch />
                </IconButton>
              </Tooltip>
              <Tooltip title="Add Influencer">
                <IconButton
                  onClick={handleOpen}
                  sx={{
                    border: "none",
                    background: "#6B8E76",
                    "&:hover": {
                      background: "#6B8E76",
                    },
                  }}
                >
                  <FiPlus color="#fff" />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
          <Box>
            <Tabs value={selectedTab} onChange={handleChange}>
              <Tab label={"Pending"} value={"pending"} />
              <Tab label={"Approved"} value={"approved"} />
              <Tab label={"Declined"} value={"declined"} />
            </Tabs>
          </Box>
          <Box>
            {loading ? (
              <Box>
                <CircularProgress />
              </Box>
            ) : (
              <InfluencersList
                state={selectedTab}
                data={influencers}
                containerSx={{
                  maxHeight: "calc(100vh - 226px)",
                }}
                total={Math.ceil(total / limit)}
                currentPage={currentPage}
                onPageChange={(nextPage) => setCurrenPage(nextPage)}
                onUpdate={listInfluencers}
              />
            )}
          </Box>
        </Box>
        {open ? (
          <InfluencerModal open={open} handleClose={handleClose} />
        ) : (
          <></>
        )}
      </ThemeProvider>
    </>
  );
};
